export default "__VITE_ASSET__HoS3ZUYS__"